import EventBus from "@/lib/eventBus"

export default {
  created() {
    this.listeners = []
  },

  beforeDestroy() {
    this.listeners.forEach(el => this.removeListener(el.name, el.action))
  },

  methods: {
    fireEvent(name, payload) {
      EventBus.$emit(name, payload)
    },
    addListener(name, action) {
      EventBus.$on(name, action)
      this.listeners.push({ name, action })
    },
    removeListener(name, action) {
      EventBus.$off(name, action)
      this.listeners = this.listeners.filter(el => {
        !el == { name, action }
      })
    }
  }
}
